import { Typography } from '@mui/material';
import React from 'react';
import ContractorList from '../../components/Contractors/Owner/ContractorList';

const ContractorListPage = () => {
    return (
        <>
            <Typography variant='h1' sx={{ textTransform: 'uppercase' }}>
                Contractors
            </Typography>
            <ContractorList />
        </>
    );
};

export default ContractorListPage;
